import React from 'react';
import { Typography } from 'antd';
import PropTypes from 'prop-types';

const WorkExpDescription = ({ gb_seniority_improvement_conversion }) => {
  return gb_seniority_improvement_conversion === 'sic_banner_change' ? (
    <div className='new-mcq-work-exp-description-wrapper'>
      <Typography.Text className="new-mcq-work-exp-description">
        <ul>
          <li className='disc-bullet-list-item'>
              This is a multiple-choice survey to understand your work style and role in previous projects.
          </li>
          <li className='disc-bullet-list-item'>
              The result of this survey will help us match you with the right jobs.
          </li>
          <li className='star-bullet-list-item'>
              It does not require any prior preparation and does not result in failure to move to the next step.
          </li>
        </ul>
      </Typography.Text>
    </div>
  ) : (
    <div className='new-mcq-work-exp-description-wrapper'>
      <Typography.Text className="new-mcq-work-exp-description">
        We will ask you about your past projects, product involvement and experience working with other engineers.
        This will help us find the right jobs for you.
      </Typography.Text>
    </div>
  );
};

WorkExpDescription.propTypes = {
  gb_seniority_improvement_conversion: PropTypes.string
};
export default WorkExpDescription;
